<template>
	<div class="filter">
		<div class="filter-title">
			<h1>Usuários</h1>
		</div>
		<div class="filter-inputs">
			<GenericMultiselect
				class="status-multiselect"
				:customClass="'mt-0'"
				ref="status"
				:options="statusOptions"
				:placeholder="'Status'"
				:fullWidth="!isWeb"
				:searchable="false"
				:needType="true"
				:type="'status'"
				:clearOnOpen="false"
				@changeInput="changeInput"
			/>
			<input
				class="filter-inputs__users"
				type="text"
				placeholder="Busca"
				@input="searchInputDebounce"
				v-model="searchInput"
			/>
			<ButtonPrimary
				class="filter-inputs__btn"
				label="Adicionar Usuário"
				size="md"
				@click="addUser"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';

export default {
	name: 'TableFilter',
	components: { GenericMultiselect, ButtonPrimary },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		searchInput: null,
		debounce: null,
	}),
	created() {},
	mounted() {},
	methods: {
		addUser() {
			this.$router.push({
				path: '/dashboard/user/detail',
			});
		},
		changeInput(param) {
			let selectedStatus = !param.value ? null : param.value.id;
			this.$emit('searchFromStatusInput', selectedStatus);
		},
		searchInputDebounce() {
			clearTimeout(this.debounce);

			this.debounce = setTimeout(() => {
				this.$emit('searchFromInput', this.searchInput);
			}, 600);
		},
	},
	computed: {
		...mapGetters('userManagement', ['statusList']),
		statusOptions() {
			const options = this.statusList != undefined ? this.statusList : [];

			return !options.length ? [] : options;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'TableFilter.scss';
</style>
